export const assetsBaseUrl = process.env.NODE_ENV === 'production' ? '/calculator' : '';

const getApiUrl = (version) => {
    const { hostname } = window.location;
    let api = version !== 2 ? 'https://api.hypotheker.nl' : 'https://api.hypotheker.nl/v2';

    if (hostname.indexOf('staging') !== -1) {
        api = version !== 2 ? 'https://api.hypotheker.nl' : 'https://staging-api.hypotheker.nl/v2';
    }

    if (hostname.indexOf('test') !== -1) {
        api = version !== 2 ? 'https://testapi.hypotheker.nl' : 'https://test-api.hypotheker.nl/v2';
    }

    if (hostname.indexOf('acc') !== -1) {
        api = version !== 2 ? 'https://acpapi.hypotheker.nl' : 'https://test-api.hypotheker.nl/v2';
    }

    if (hostname.indexOf('localhost') !== -1) {
        api = version !== 2 ? 'https://api.hypotheker.nl' : 'https://test-api.hypotheker.nl/v2';
    }

    return api;
};

export const getShortUrl = async (url, addOn) => {
    if (!addOn) {
        addOn = '';
    }

    let data = {
        group_guid: 'Be33b2VNMyq',
        domain: 'berekenen.hypotheker.nl',
        long_url: `${url}${addOn}`,
    };

    let response = await fetch('https://api-ssl.bitly.com/v4/shorten', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            //Authorization: "Bearer f8c2e48062804025e994e7d98d37e2ad0517812e"
            Authorization: 'Bearer b4916c1b36fb25378359c58936862bfc3d1e3d15',
        },
        body: JSON.stringify(data),
    });

    return response.json();
};

export const getMortgageProviders = async (
    MortgageType,
    IsNieuwbouw,
    RenteBasis,
    RentevastePeriode,
) => {
    let response = await fetch(
        `${getApiUrl(
            2,
        )}/interestrates/hypotheekaanbieders?HypotheekVorm=${MortgageType}&IsNieuwbouw=${IsNieuwbouw}&RenteBasis=${RenteBasis}&RentevastePeriode=${RentevastePeriode}`,
        {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        },
    );

    return response.json();
};
